<template>
  <el-dialog
    title="收货地址"
    :visible.sync="dialog"
    width="30%"
    @close="closeDialog(0)"
  >
    <ul class="deliver_goods">
      <li>
        订单编号
        <span>{{ formData.ordersn }}</span>
      </li>
      <li>
        下单时间
        <span>{{ formData.create_time }}</span>
      </li>
      <li>
        收货信息
        <span>{{ formData.address }}</span>
      </li>
      <li>
        快递公司
        <span>
          <el-select v-model="form.express" filterable>
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.logi_name"
              :value="item.logi_code"
            ></el-option>
          </el-select>
        </span>
      </li>
      <li>
        快递单号
        <span>
          <el-input v-model="form.logi_no" auto-complete="off"></el-input>
        </span>
      </li>
    </ul>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog(0)">取 消</el-button>
      <el-button type="primary" @click="save()" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { postcompany, Delivery } from "@/api/order";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  watch: {
    showDialog(val) {
      this.dialog = val;
    }
  },
  data() {
    return {
      form: {},
      list: [],
      dialog: false,
      loading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      postcompany({ token: this.token, app_id: this.app_id }).then(res => {
        this.list = res.data;
      });
    },
    closeDialog(rel) {
      this.$emit("close", rel);
    },
    save() {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.formData.ordersn,
        ship_type: 1,
        logi_code: this.form.express,
        logi_no: this.form.logi_no
      };
      console.log(data);
      Delivery(data).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "发货成功"
          });
          this.closeDialog(1);
        }else{
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.deliver_goods {
  width: 100%;
  li {
    padding: 10px;
    span {
      margin-left: 20px;
      .el-input {
        width: 205px;
      }
    }
  }
}
</style>
